export function isDev(): boolean {
  return import.meta.env.DEV
}
